import styled from 'styled-components'
import { CommandButton } from '@fluentui/react/lib/Button'
import { ICON_NAMES } from '../../common/src/msIcons'

const styles = {
  white: {
    icon: {
      fontSize: '14px',
      color: `${p => p.theme.palette.white}`,
    },
    iconHovered: {
      color: `${p => p.theme.palette.themeLight}`,
    },
    menuIcon: {
      color: `${p => p.theme.palette.white}`,
    },
    menuIconHovered: {
      color: `${p => p.theme.palette.themeLight}`,
    },
  },
  default: {
    icon: {
      fontSize: '14px',
    },
  },
}

export const OptionsMenuButton = styled(CommandButton).attrs(props => ({
  iconProps: {
    iconName: ICON_NAMES.CollapseMenu,
  },
  styles: {
    ...(props.white ? styles.white : styles.default),
  },
}))`
  height: auto;
  margin: 0 0 0 8px;
  padding: 0;
`
